import { eTipoPermissao } from '@/enums/ePermissoes';
import { TIPO_ESTRUTURA_PPI } from '@/models/educacaoinclusiva/pdiestrutura/tipo-estrutura';

export default [
  {
    description: 'Estrutura do PPI',
    path: '/educacaoinclusiva/ppi-estrutura',
    name: 'ppi_estrutura',
    component: () => import('@/views/educacaoinclusiva/ppi-estrutura/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.ESTRUTURADOPPI_MENU_2300200100],
      tipoEstrutura: TIPO_ESTRUTURA_PPI,
    },
    goesToMenu: true,
  },
];
